import {BaseFormModel} from './base-form-model';
import {MenuModifierGroup} from './menu-modifier-group';

export class MenuItemModifierGroup extends BaseFormModel<MenuItemModifierGroup> {
    id: number;
    menuModifierGroup: MenuModifierGroup;
    sortOrder: number;
}
